/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

const fetchFieldPromises = (exploreVM, dataSourceId) => {
	const all = exploreVM
		.getSmartsRecommenderWrapper()
		.getMetadataColumns(dataSourceId)
		.then((columns) => {
			return columns.map((col) => {
				return {
					name: col.getLabel(),
					id: col.getId()
				};
			});
		});

	const interesting = all.then(
		() => {
			return exploreVM
				.getSmartsRecommenderWrapper()
				.recommendInterestingFields(dataSourceId);
		});

	return {
		all, interesting
	};
};

//Deprecated
const fetchFields = (exploreVM, dataSourceId) => {
	const { all,interesting } = fetchFieldPromises(exploreVM, dataSourceId);

	return Promise.all([all,interesting]).then(
		([all, interesting]) => ({ all, interesting })
	);
};

const fetchRecommendations = (exploreVM, fieldIds) => {
	return exploreVM.getSmartsRecommenderWrapper()
		.recommendRelatedVisualizationsAsWidgetSpecs(
			exploreVM.activeDataSourceId,
			fieldIds,
			{ includeBestVisForTargetFields : true }
		);

};

export {
	fetchFields,
	fetchFieldPromises,
	fetchRecommendations
};



// WEBPACK FOOTER //
// ./src/js/util/FetchSmartsData.js